import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { persistStore, autoRehydrate } from "redux-persist";
import { createFilter, createBlacklistFilter } from "redux-persist-transform-filter";
// import { forEach } from 'lodash'

// Import any parts of the store that need to persist across page loads (cart items, user, etc)
// import persistances from './persistances'

import { setPersisted } from "./actions/persist";
import { userCheckLogin } from "./actions/user";

// import { routerMiddleware } from 'react-router-redux'
// import createHistory from 'history/createBrowserHistory'
// export const history = createHistory()

export default function configureStore(preloadedState = {}) {
	// const initialState = {}
	const enhancers = [];
	enhancers.push(autoRehydrate());

	const middleware = [
		thunk
		// routerMiddleware(history)
	];

	if (process.env.NODE_ENV === "development") {
		const devToolsExtension =
			typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;

		if (typeof devToolsExtension === "function") {
			enhancers.push(devToolsExtension());
		}
	}

	const composedEnhancers = compose(
		applyMiddleware(...middleware),
		...enhancers
	);

	// Load either passed in state, or localStorage state
	const persistedState = preloadedState !== {} ? preloadedState : {}; // : loadState()

	// Persist certain parts of the store (cart, user login, etc)
	// const oldState = loadState()
	// if(oldState){
	// 	forEach(persistances, (value) => {
	// 		persistedState[value] = oldState[value] ? oldState[value] : {}
	// 	})
	// }

	// console.log("oldState:", oldState)
	// console.log("Store preloadedState:", preloadedState)
	// console.log("Store persistedState:", persistedState)

	const store = createStore(rootReducer, persistedState, composedEnhancers);

	if (process.env.NODE_ENV !== "production") {
		if (module.hot) {
			module.hot.accept("./reducers", () => {
				store.replaceReducer(rootReducer);
			});
		}
	}

	// store.subscribe(() => {
	// 	saveState(store.getState())
	// })
	// console.log(self)
	// console.log(this)
	// console.log(window)

	// Only persist the users themselves (not errors)
	const userFilter = createFilter("user", ["admin", "customer", "guest"]);

	// Only persist useful data for checkout
	const checkoutFilter = createFilter("checkout", [
		"activeSection",
		"activePayment",
		"delivery",
		"shipping",
		"billing",
		"order",
		"payment"
	]);

	// Only persist useful data for enews
	const eNewsFilter = createFilter("enews", ["success"]);

	// Blacklist un-usefull stuff
	const cartBlacklistFilter = createBlacklistFilter("cart", [
		"couponInProcess",
		"couponError",
		"couponSuccess",
		"couponDeleteError",
		"inProccess",
		"success"
	]);

	if (typeof window !== "undefined") {
		persistStore(
			store,
			{
				whitelist: ["cart", "user", "checkout", "enews"],
				transforms: [userFilter, checkoutFilter, eNewsFilter, cartBlacklistFilter]
			},
			() => {
				// Once store has persisted, let the app know about it
				store.dispatch(setPersisted());
				store.dispatch(userCheckLogin("admin"));
			}
		);
	}
	// console.log(store.getState())

	return store;
}



// WEBPACK FOOTER //
// ./src/store/index.js